import { Endpoint } from '@/types/api.type.ts';

export const cityEndpoints: Endpoint[] = [
    {
        name: 'getCities',
        method: 'get',
        path: '/cities/',
    },
    {
        name: 'getCity',
        method: 'get',
        path: '/cities/:id',
    },
    {
        name: 'createCity',
        method: 'post',
        path: '/cities',
    },
    {
        name: 'updateCity',
        method: 'patch',
        path: '/cities/:id',
    },
    {
        name: 'activateCity',
        method: 'patch',
        path: '/cities/:id',
    },
    {
        name: 'deactivateCity',
        method: 'patch',
        path: '/cities/:id',
    },
    {
        name: 'getAllCities',
        method: 'get',
        path: '/cities/all',
    },
];
